import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../modules/auth-core/data/service/authentication.service';

@Injectable()
export class L57AdminGuard implements CanActivate {

	constructor(private authService: AuthenticationService, private router: Router) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
		const allowed = (this.authService.token != null && this.authService.isSuper);

		if (!allowed) {
			this.router.parseUrl('/auth/login');
			return false;
		}

		return true;
	}
}
